import React, { useCallback } from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { withTranslation } from 'react-i18next'
import { Form } from 'react-bootstrap'
import ArraySelect from '../Select/ArraySelect'

const StyledWrapper = styled.div`
  margin-bottom: 30px;
`
const CatalogSelector = (props) => {
  const { t, teamOrderStore, productsStore } = props

  const handleChangeCatalog = useCallback(
    async (catalog) => {
      if (catalog.isExternal) {
        const catalogExternalUrl = await apiClient.getJson(
          APIEndpoints.externalCatalogs(catalog.id),
          { shoppingbasketId: productsStore.basket.id }
        )

        if (catalogExternalUrl.redirectUrl) {
          window.open(
            catalogExternalUrl.redirectUrl,
            catalogExternalUrl.target ? catalogExternalUrl.target : '_blank'
          )
        } else {
          console.log('no redirectUrl in response given')
        }

        return
      }

      teamOrderStore.setCatalog(catalog.id)
    },
    [teamOrderStore, productsStore.basket.id]
  )

  return (
    <StyledWrapper>
      {teamOrderStore.articleCatalogs.length > 0 && (
        <Form.Group>
          <Form.Label>{t('ProductOverview:selectCatalogue')}</Form.Label>

          <ArraySelect
            noAutoSelect
            options={teamOrderStore.articleCatalogs}
            value={teamOrderStore.selectedCatalog}
            onChange={handleChangeCatalog}
          />
        </Form.Group>
      )}
    </StyledWrapper>
  )
}

export default withTranslation()(
  inject(
    'uiStore',
    'productsStore',
    'teamOrderStore'
  )(observer(CatalogSelector))
)
